import { IYearMonth } from '@/coreDomainsModule/date';
import { IAnnounce } from '@/coreDomainsModule/entities/forecast';
import { DateService } from '@/coreDomainsModule/services/dateService';
import {
  BulkPostSupplierForecastRequest,
  PostSupplierForecastRequestInfo,
} from '@/coreInfrastructureModule/axios/generated/supplierForecastManage';

/**
 * UI用の型をAPIリクエストの型に変換する
 */
export class putSupplierForecastAdapter {
  /**
   * フロント側の発注情報の型、IAnnounceからBulkPostSupplierForecastResponseInfoに変換を行う
   * @param registerSupplierForecastInfo - 登録を行う仕入先内示情報
   * @param equalCustomerForecast - 客先内示と同じかどうか(フラグみたいな)
   * @param createdYearMonth - 仕入先内示作成月
   * @param registerSupplierForecastRange - 登録する仕入先内示の期間
   * @param aggregateBusinessId - 集計ID
   */
  public static adapt = (
    registerSupplierForecastInfo: IAnnounce[],
    equalCustomerForecast: boolean,
    createdYearMonth: IYearMonth,
    registerSupplierForecastRange: number,
    aggregateBusinessId: string
  ): Array<PostSupplierForecastRequestInfo> => {
    // 客先内示と同じにするかどうかを判定する
    // 仕入先内示を新たに作成して登録する
    // 仕入先内示の選択範囲
    const period = registerSupplierForecastRange + 1; // 配列からループで取り出す長さの指定なので、+1する
    const registerSupplierForecastInfoList: PostSupplierForecastRequestInfo[] = [];
    for (let updateMonth = 0; updateMonth < period; updateMonth++) {
      const targetYearMonth = DateService.updateYearMonth(createdYearMonth.year, createdYearMonth.month, updateMonth);
      const res = registerSupplierForecastInfo.find(
        (ent) => ent.year === targetYearMonth.updateYear && ent.month === targetYearMonth.updateMonth
      );
      if (!res) continue;
      registerSupplierForecastInfoList.push({
        aggregateBusinessId: aggregateBusinessId,
        supplierForecastCreatedYear: createdYearMonth.year,
        supplierForecastCreatedMonth: createdYearMonth.month,
        supplierForecastTargetYear: res.year,
        supplierForecastTargetMonth: res.month,
        supplierForecastAmount: res.amount,
        equalCustomerForecastDataFlag: equalCustomerForecast,
      });
    }
    return registerSupplierForecastInfoList;
  };
}
